import { ID } from '@sdk/common/types';
import { api } from '@sdk/api/useSlingApi';

export const useDashboardNotificationAction = () => {
  const invoke = async ({ id, url }: { id: ID; url: string }) => {
    await api.httpPost(url);

    // @TODO: updating list of notifications when it will be stored in react
    // Currently it will be auto-refreshed in angular via websocket

    return id;
  };

  return { invoke };
};
